import { RadioButtonMode } from './type';

const getRadioButtonMode = ({
  checked,
  finished,
}: {
  checked: boolean | undefined;
  finished: boolean | undefined;
}): RadioButtonMode => {
  if (checked) {
    return 'checked';
  }
  if (finished) {
    return 'finished';
  }

  return 'empty';
};

export default getRadioButtonMode;
